import { Box } from "@mui/material";
import ErrorAlert from "./ErrorAlert";
import SuccessAlert from "./SuccessAlert";
import WarningAlert from "./WarningAlert";

const Alert = ({ messages = [] }) => {
  const Components = {
    error: ErrorAlert,
    success: SuccessAlert,
    warn: WarningAlert,
  };
  return (
    <Box
      width={{ lg: "fit-content", md: "fit-content", sm: "fit-content", xs: "95%" }}
      maxWidth={{ lg: 800, md: 650, sm: 600, xs: "95%" }}
      minWidth={{ lg: 400, md: 400, sm: 400, xs: "95%" }}
      position="fixed"
      bottom="2.5%"
      left="2.5%"
      sx={{ zIndex: 1500 }}
    >
      {messages.map((message) => {
        const Component = Components[message.type];
        return <Component key={message.id} message={message.text} id={message.id} />;
      })}
    </Box>
  );
};

export default Alert;
